// extracted by mini-css-extract-plugin
var _1 = "Ry2Gj264GL";
var _2 = "PJ_JHydaX3";
var _3 = "TNQAjxmLNF";
var _4 = "xF3JzLWIhC";
var _5 = "abkQMfs6nA";
var _6 = "sugydLGZKI";
export { _1 as "flexGrow1", _2 as "flexGrow2", _3 as "flexGrow3", _4 as "flexGrow4", _5 as "flexGrow5", _6 as "root" }
